import React from 'react';
import Button from '@material-ui/core/Button';

import { get } from 'lodash-es';

export const showAlerts = ({ enqueueSnackbar, alerts, strings = {}, dismiss = true }) => {
  try {
    if (enqueueSnackbar && alerts) {
      const errors = alerts.getIn(['errors']);
      const warnings = alerts.getIn(['warnings']);
      const infos = alerts.getIn(['infos']);
      const successes = alerts.getIn(['successes']);
      if (errors) {
        errors.forEach(alert => {
          const msg = alert.get('msg');
          if (typeof msg === 'string') {
            enqueueSnackbar(get(strings, msg, msg), {
              variant: 'error',
              preventDuplicate: false,
              autoHideDuration: undefined,
              action: dismiss ? (
                <Button color="inherit" size="small">
                  {strings['common.button.dismiss.label'] || 'Effacer'}
                </Button>
              ) : (
                undefined
              ),
            });
          }
        });
      }
      if (warnings) {
        warnings.forEach(alert => {
          const msg = alert.get('msg');
          enqueueSnackbar(get(strings, msg, msg), {
            variant: 'warning',
            preventDuplicate: false,
            autoHideDuration: 7000,
            action: dismiss ? (
              <Button color="inherit" size="small">
                {strings['common.button.dismiss.label'] || 'Effacer'}
              </Button>
            ) : (
              undefined
            ),
          });
        });
      }
      if (infos) {
        infos.forEach(alert => {
          const msg = alert.get('msg');
          enqueueSnackbar(get(strings, msg, msg), {
            variant: 'info',
            preventDuplicate: false,
            autoHideDuration: 7000,
            action: dismiss ? (
              <Button color="inherit" size="small">
                {strings['common.button.dismiss.label'] || 'Effacer'}
              </Button>
            ) : (
              undefined
            ),
          });
        });
      }
      if (successes) {
        successes.forEach(alert => {
          const msg = alert.get('msg');
          enqueueSnackbar(get(strings, msg, msg), {
            variant: 'success',
            preventDuplicate: false,
            autoHideDuration: 7000,
            action: dismiss ? (
              <Button color="inherit" size="small">
                {strings['common.button.dismiss.label'] || 'Effacer'}
              </Button>
            ) : (
              undefined
            ),
          });
        });
      }
    }
  } catch (e) {
    // do nothing
    // eslint-disable-next-line no-console
    console.log(e);
  }
};

export const getOptions = selection => {
  if (typeof selection === 'undefined') return [];
  try {
    return selection.toArray().map(option => ({ value: option.get(0), text: option.get(1), label: option.get(1) }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return [];
  }
};
